module.exports = __webpack_public_path__ + "static/media/ArrowLeft.3fce1ee7.svg";